const defaultLang = {
    idlanguage : '1',
    code : 'EN'
};


export const englishLang =  {
    idlanguage : '1',
    code : 'EN'
}

export const frenchLang = {
    idlanguage : '2',
    code : 'FR'
}

export default defaultLang;